<template>
    <div>
        <b-spinner v-if="isLoading" type="grow" label="Loading..." class="loading" />
        <b-row v-else>
            <b-modal id="modal-add-appointment" ok-only :ok-title="$t('site.save')" centered @ok="save" size="lg"
                :title="$t('quran_programs.add_appointment')">
                <b-row>
                    <b-col md="4">
                        <b-form-group>
                            <h5>{{ $t("quran_programs.quran_program_time") }}</h5>
                            <flat-pickr v-model="newData.date" class="form-control" :config="{ dateFormat: 'Y-m-d' }" />
                        </b-form-group>
                    </b-col>

                    <b-col lg="4">
                        <b-form-group>
                            <h5>{{ $t("quran_programs.start_at") }}</h5>
                            <b-form-timepicker v-model="newData.start" locale="ar-EG" />
                        </b-form-group>
                    </b-col>
                    <b-col lg="4">
                        <b-form-group>
                            <h5>{{ $t("quran_programs.end_at") }}</h5>
                            <b-form-timepicker v-model="newData.end" locale="ar-EG" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-modal>
            <b-col md="3" v-for="(item, index) in paginatedItems" :key="item.id">
                <b-card no-body class="card-developer-meetup">
                    <div class="bg-light-primary rounded-top text-center">
                        <b-img :src="sideImg" style="width: 100%" />
                    </div>
                    <b-card-body>
                        <div class="meetup-header d-flex align-items-center">
                            <div class="meetup-day">
                                <h3 class="mb-0">
                                    {{ item.alward }}
                                </h3>
                            </div>
                            <div class="my-auto">
                                <b-card-title class="mb-25">
                                    الجزء : {{ item.partNumber }}
                                </b-card-title>
                                <b-card-text class="mb-0">
                                    <b-badge variant="success" class="badge-glow">
                                        الحزب :{{ item.alhizb }}
                                    </b-badge>
                                    --
                                    <b-badge variant="info" class="badge-glow">
                                        الربع :{{ item.quarter }}
                                    </b-badge>
                                </b-card-text>
                            </div>
                        </div>
                        <hr />

                        <b-media no-body>
                            <b-media-aside class="mr-1">
                                <b-avatar rounded variant="light-primary" size="34">
                                    <feather-icon icon="CalendarIcon" size="18" />
                                </b-avatar>
                            </b-media-aside>
                            <b-media-body>
                                <h6 class="mb-0">اعضاء هيئة التدريس</h6>
                                <small v-if="item.data && item.data.teachers && item.data.teachers.length > 0">
                                    <b-badge variant="light-primary">{{ item.data.teachers[0].full_name }}</b-badge>
                                </small>
                            </b-media-body>
                        </b-media>
                        <b-media no-body>
                            <b-media-aside class="mr-1">
                                <b-avatar rounded variant="light-primary" size="34">
                                    <feather-icon icon="CalendarIcon" size="18" />
                                </b-avatar>
                            </b-media-aside>
                            <b-media-body>
                                <h6 class="mb-0">
                                    {{ $t("quran_programs.quran_program_time") }}
                                </h6>
                                <small v-if="checkAllowedSelectTime(item)">
                                    <b-badge v-if="$role != 'student'" variant="light-info"
                                        v-b-modal.modal-add-appointment @click="setSelectItem(item)">
                                        <span class="align-middle">تحديد الموعد </span>
                                    </b-badge>
                                </small>

                                <small v-if="item.data && item.data.online_session">
                                    <b-badge variant="light-primary">
                                        {{ item.data.online_session.start_in }}
                                    </b-badge>
                                </small>
                            </b-media-body>
                        </b-media>

                        <template v-if="item && item.data && item.data.online_session">
                            <hr />
                            <b-row>
                                <b-col lg="12" class="text-center">
                                    <b-card-text class="mb-0"> الاجتياز بنجاح </b-card-text>
                                    <b-form-checkbox value="1" v-model="item.data.complete"
                                        class="custom-control-success" name="check-button" switch :disabled="$role == 'student' || item.data.complete == 1
                                            " @change="complete(item.data)">
                                        <span class="switch-icon-left">
                                            <feather-icon icon="CheckIcon" />
                                        </span>
                                        <span class="switch-icon-right">
                                            <feather-icon icon="XIcon" />
                                        </span>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>

                            <hr />
                            <b-row>
                                <b-col lg="6">
                                    <b-button variant="gradient-primary" @click="openLive(item.data)" block>
                                        <i class="fas fa-door-open"></i>
                                    </b-button>
                                </b-col>
                                <b-col lg="6">
                                    <b-button variant="gradient-info" :to="{
                                        name: 'OnlineDetails',
                                        params: {
                                            id: item.data.online_session.id,
                                        },
                                    }" block>
                                        <i class="fas fa-photo-video"></i>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </template>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <b-pagination v-model="currentPage" align="fill"
            class="dataTables_paginate paging_simple_numbers pagination-warning" :total-rows="items.length"
            :per-page="perPage" @input="onPageChange(currentPage)" limit="15">
            <template v-slot:next-text>
                <i class="fas fa-angle-left" />
            </template>
            <template v-slot:prev-text>
                <i class="fas fa-angle-right" />
            </template>
            <template v-slot:first-text>
                <i class="fas fa-step-forward" />
            </template>
            <template v-slot:last-text>
                <i class="fas fa-step-backward" />
            </template>
        </b-pagination>

    </div>

</template>

<script>
import controller from "@/Controllers/QuranScheduleDateController";
import QuranPrograms from "@/Controllers/QuranProgramsController";
import flatPickr from "vue-flatpickr-component";
import OnlineSessionController from "@/Controllers/OnlineSessionController";

const ctr = new controller();
let quranProgramCtr = new QuranPrograms();

export default {

    async created() {
        //get quranProgram data to get saveType , period started with
        let quranProgram = await quranProgramCtr.Show(this.$route.params.id);
        //calculate how many wards should exists from saveType and period
        let numberOfWards = 0;
        let saveType = quranProgram.SaveType;
        let period = quranProgram.period;
        //store to be able to use in getLastWard independently
        this.saveType = saveType;
        this.period = period;
        //testers
        // let saveType = 'desc';
        // let period = 5;
        if (saveType == 'desc') {
            numberOfWards = period * 8;
        } else {
            numberOfWards = (30 - period + 1) * 8
        }

        //setup items
        // partNumber == period
        for (let i = 1; i < numberOfWards + 1; i++) { //+1 since i = 1
            let partNumber = saveType == 'asc' ? period + Math.floor((i - 1) / 8) : period - Math.floor((i - 1) / 8);

            // Calculate the quarter (1-4)
            let quarter = ((i - 1) % 4) + 1;

            // Calculate the hizb (1 or 2)
            let alhizb = Math.ceil((i % 8) / 4);
            if (alhizb === 0) alhizb = 2; // Handle the case when i % 8 is 0

            this.items.push({
                alward: (partNumber - 1) * 8 + (quarter + (alhizb - 1) * 4),
                partNumber: partNumber,
                alhizb: alhizb,
                quarter: quarter
            });
        }

        //hydrate items with data
        await this.hydrateItems();

        // navigate to corresponding page
        if (this.lastWardCompleted) {
            let lastCompletedIndex = this.items.findIndex(
                (item) => item.alward === this.lastWardCompleted
            );

            if (lastCompletedIndex !== -1) {
                this.currentPage = Math.ceil((lastCompletedIndex + 1) / this.perPage);
            }
        }

        this.isLoading = false;
    },
    components: {
        flatPickr,
    },
    computed: {
        paginatedItems() {
            const start = (this.currentPage - 1) * this.perPage;
            const end = start + this.perPage;
            return this.items.slice(start, end);
        },
    },
    data() {
        return {
            sideImg: require("@/assets/images/pages/buldozer.png"),
            numberOfWards: 240,
            items: [],
            currentPage: 1,
            perPage: 8,
            isLoading: true,
            lastWardCompleted: null,
            saveType: null,
            period: null,
            newData: {},
        }
    },
    methods: {
        apiParamsConverter() {
            const apiParams = { per_page: 240 };
            apiParams.with = ["teachers", "onlineSession", "students"];
            apiParams.filter = "quran_program_id|" + this.$route.params.id;
            apiParams.sort = "created_at|asc";
            return apiParams;
        },
        onPageChange(page) {
            this.currentPage = page;
        },
        checkAllowedSelectTime(item) {
            //Completed
            if (item.data && item.data.complete == 1) return false;
            //If not completed get the order of current
            //If saveType == asc , so the order should be on the next ward not completed
            //If no data mean no assigned time
            //If online_class_id != 0 means that already assigned time
            if (this.saveType == 'asc') {
                if (item.alward === this.lastWardCompleted + 1) {
                    return !item.data || item.data.onlline_class_id === 0;
                }
            } else {
                //if last ward finished is last ward of current period means we need to shift backward
                //for example alward 16 (last of period 2), next one will be 1 (last of period 1)
                //else the next should have the order to assign normally
                if (this.lastWardCompleted % 8 == 0) {
                    if (this.lastWardCompleted - 15 == item.alward) {
                        return !item.data || item.data.onlline_class_id === 0;
                    }
                } else {
                    if (item.alward == this.lastWardCompleted + 1) {
                        return !item.data || item.data.onlline_class_id === 0;
                    }
                }
            }

            return false;
        },
        setSelectItem(item) {
            this.newDate = {};
            this.selectItem = item;
        },
        async hydrateItems() {
            const response = await ctr.GetAll(this.apiParamsConverter());
            const data = response.data;
            this.items.forEach(item => {
                const matchingItem = data.find(dataItem => dataItem.alward === item.alward);
                item.data = matchingItem ?? null;
            });

            //get last ward completed
            this.lastWardCompleted = this.getLastWardCompleted(this.items);
            if (!this.lastWardCompleted) { //just started no previous completted
                //make the last ward = the first ward should be taken - 1 in asc
                if (this.saveType == 'asc') {
                    this.lastWardCompleted = (this.period * 8) - 7 - 1
                } else {
                    this.lastWardCompleted = (this.period * 8) + 8
                }
            }

        },
        getLastWardCompleted(items) {
            if (!items || items.length === 0) return null;
            const completedItems = items.filter(item => item.data && item.data.complete === 1);


            if (completedItems.length === 0) return null;
            if (this.saveType === 'asc') {

                return completedItems.reduce((max, item) => item.alward > max.alward ? item : max).alward;
            } else {

                const minWard = completedItems.reduce((min, item) => item.alward < min.alward ? item : min).alward;
                const start_of_period_to_check_in_ward = minWard;
                const end_of_period_to_check_in_ward = minWard + 8 - 1; // 8 wards in a period
                
                const filteredWards = completedItems.filter(item => {
                    const ward = item.data.alward;                    
                    return ward >= start_of_period_to_check_in_ward && ward <= end_of_period_to_check_in_ward;
                });

                const maxWard = filteredWards.reduce((max, item) => item.alward > max.alward ? item : max).alward

                return maxWard;
            }

        },
        async complete(item) {
            this.isLoading = true;
            await ctr.Updata(item);
            await this.hydrateItems();
            this.isLoading = false;
        },
        async save() {
            this.isLoading = true;
            if (this.selectItem.data) {
                this.newData.id = this.selectItem.data.id;
                this.newData.onlline_class_id = this.selectItem.data.onlline_class_id;
            }
            this.newData.alward = this.selectItem.alward;

            this.newData.quran_program_id = this.$route.params.id;

            this.newData.title =
                "- الجزء" +
                this.selectItem.partNumber +
                " - الحزب - " +
                this.selectItem.alhizb +
                "- الربع - " +
                this.selectItem.quarter;

            this.newData.systemic = 1;
            await ctr.From(this.newData, "FormData");

            await this.hydrateItems();
            this.isLoading = false
        },
        openLive(data) {
            new OnlineSessionController().joinLecture(data.online_session.id);
        },
    }

}


</script>